import React, { Fragment, useContext, useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { Tab, Nav, Spinner } from "react-bootstrap";
import { Link } from "react-router-dom";
import CardCarousel from "./Components/CardCarousel";
import AuthContext from "./Context/auth/AuthContext";
import TabConfig from "./Config/TabConfig.json";


const UserApps = () => {
  const authContext = useContext(AuthContext);
  const {
    isAuthenticated,
    user,
    apps,
    loadUserApps,
    getAppsList,
    appsLoaded,
    appsLoading,
  } = authContext;
  const history = useHistory();
  const [mode, setMode] = useState("Public");
  const [visibleApps, setVisibleApps] = useState([]);
  // const [loaded, setLoaded] = useState(false);
  // console.log("USER APPS", apps, TabConfig);
  // console.log("USER APPS", appsLoading);
  // console.log("USER APPS", apps && apps.length > 0 && !appsLoading);
  const loadAppsList = async () => {
    const tmpApps = await getAppsList();
    // console.log("PUB APPS REFRESHED", tmpApps);
    setVisibleApps(tmpApps);
  };

  const fetchUserApps = async () => {
    const tmpApps = await loadUserApps();
    // console.log("USER APPS REFRESHED", tmpApps);
    setVisibleApps(tmpApps);
  };

  useEffect(() => {
    // const getAppsList = async () => {
    //   const config = {
    //     headers: {
    //       "Content-Type": "application/json",
    //     },
    //   };
    //   // if (users.length === 0)
    //   //   axios.get("/users.json").then((response) => {
    //   //     // setPortal(...portal, { users: response.data });
    //   //   });
    //   if (apps.length === 0)
    //     await axios
    //       .post("/appslist", {}, config)
    //       .then((response) => {
    //         console.log("APPS", response);
    //         const apps = response.data.filter((item) => !item.exclude);
    //         setApps(apps);
    //         setLoaded(true);
    //       })
    //       .catch((err) => {
    //         console.log("Error Fetching APPs", err);
    //       });
    // };
    if (!user && !apps && !appsLoaded) {
      loadAppsList();
    }
  }, []);

  useEffect(() => {
    if (user) {
      // console.log("USER APPS REFRESHING...");
      fetchUserApps();
      // loadAppsList();
    }
  }, [user]);

  // useEffect(() => {
  //   console.log("APPS REFRESHED", apps);
  //   // setVisibleApps(apps);
  //   if (user && appsLoaded) {
  //     console.log("USER APPS REFRESHED");
  //   }
  // }, [apps]);

  // useEffect(() => {
  //   if (userApps) {
  //     setApps(userApps);
  //   }
  // }, [userApps]);
  // useEffect(async () => {
  //   const config = {
  //     headers: {
  //       "Content-Type": "application/json",
  //     },
  //   };
  //   // if (users.length === 0)
  //   //   axios.get("/users.json").then((response) => {
  //   //     // setPortal(...portal, { users: response.data });
  //   //   });
  //   if (apps.length === 0)
  //     await axios.post("/appslist", {}, config).then((response) => {
  //       console.log("APPS", response);
  //       setApps(response.data);
  //     });
  // }, []);

  const getAppsByTab = (tabName) => {
    // console.log("Total Applist:", apps);
    const appsList = apps.filter(
      (item) => appsLoaded && item.portalTab === tabName
    );
    // console.log(`Applist by ${tabName}:`, appsList);
    return appsList;
  };
  // useEffect(() => {}, [apps]);

  return (
    <Fragment>
      <div className="home">
        <Tab.Container defaultActiveKey="all" id="home-tabs">
          <div className="home__tabs">
            <Nav>
              <Nav.Item>
                <Nav.Link eventKey="all">All Apps</Nav.Link>
              </Nav.Item>
              {TabConfig.map((ele) => (
                <Nav.Item>
                  <Nav.Link eventKey={ele.tabTitle}>
                    {ele.tabTitle} Apps
                  </Nav.Link>
                </Nav.Item>
              ))}

            </Nav>
            
            <Link to="/view-all" className="home__tabs__link">
              View All {">"}
            </Link>
          </div>
          <div className="home__card-carousel">
            <Tab.Content>
              <Tab.Pane eventKey="all">
                {apps && apps.length > 0 && !appsLoading ? (
                  <CardCarousel cardArray={apps} user={user} />
                ) : (
                  <Spinner
                    animation="border"
                    variant="primary"
                    className="home__card-carousel__spinner"
                  />
                )}
              </Tab.Pane>
              {TabConfig.map((ele) => (
                <Tab.Pane eventKey={ele.tabTitle}>
                  {appsLoaded && (
                    <CardCarousel cardArray={getAppsByTab(ele.tabTitle)} />
                  )}
                </Tab.Pane>
              ))}
            </Tab.Content>
          </div>
        </Tab.Container>
      </div>
      {/* <div>
        <ul className="users">
          {apps &&
            apps.map((app) => (
              <li className="user">
                <p>
                  <strong>Name:</strong> {app.name}
                </p>
                <p>
                  <strong>ID:</strong> {app.id}
                </p>
                <p>
                  <strong>Description:</strong> {app.description}
                </p>
                <p>
                  <strong>Authentication Method:</strong>{" "}
                  {app.auth_method_description}
                </p>
              </li>
            ))}
        </ul>
      </div> */}
    </Fragment>
  );
};

export default UserApps;
